import React from "react";

const Footer = () => {
  return (
    <footer className="bg-navy py-8">
      <p className="text-green capitalize dancing text-center ">
        Made with ❤ by <a href="#">khaled</a>{" "}
      </p>
    </footer>
  );
};

export default Footer;
